import { IconRefresh } from "@tabler/icons";
import { useTheme } from "styled-components";

import { useGetTraccUsagesQuery } from "@sso/apis/traccUsages/hooks";
import { TableHeader } from "@sso/components/TableHeader";
import { TableLayoutWrapper } from "@sso/components/TableLayoutWrapper";
import { TablePagination } from "@sso/components/TablePagination";
import { TableProvider, TableProviderState } from "@sso/context/tableContext";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectTraccUsagePagination } from "@sso/store/slices/traccUsage";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";

import { TraccUsageTable } from "./TraccUsageTable";
import { traccUsageTableColumns } from "./traccUsageTableColumns";

export const TraccUsages = () => {
  const theme = useTheme();

  const traccUsagePagination = useAppSelector(selectTraccUsagePagination);
  const { data, isFetching, error, refetch } = useGetTraccUsagesQuery();

  const tableContextInstance: TableProviderState = { ...traccUsagePagination, columns: traccUsageTableColumns };

  const TableActions = (
    <Flex>
      <IconButton title="Refresh" onClick={refetch}>
        <IconRefresh />
      </IconButton>
    </Flex>
  );

  return (
    <>
      {isFetching && <CircleLoading color={theme.colors.secondary.dark} size={8} blurBackground />}
      <TableProvider tableInstance={tableContextInstance}>
        <TableHeader title="TRACC Usage" TableActions={TableActions} />
        <TableLayoutWrapper error={error} data={data}>
          {data && <TraccUsageTable traccUsages={data.resources} columns={traccUsageTableColumns} />}
        </TableLayoutWrapper>
        <TablePagination totalPages={data?.totalPages} />
      </TableProvider>
    </>
  );
};
